<template>
  <div id="success">
    <div class="header">
      <div class="all_w" style="position:relative; z-index:1;">
        <div class="ttwenz" style=" text-align:center; width:100%;">
          <h4>交易详情</h4>
          <h5>支付宝安全支付</h5>
        </div>
<!--        <a href="#" @click="goToIndex" class="fh_but">返回</a>-->
      </div>
    </div>

    <div class="zfcg_box ">
      <div class="all_w">
        <img src="../assets/images/zfb_success.png" > 支付成功 </div>

    </div>
    <div class="cgzf_info">
      <div class="wenx_xx">
        <div class="mz">常州啡悦咖啡服务有限公司</div>
        <div class="wxzf_price">￥{{order.totalAmount}}</div>
      </div>

      <div class="spxx_shop">
        <div class=" mlr_pm">
          <table width="100%" border="0" cellspacing="0" cellpadding="0">
            <tr>
              <td>商   品</td>
              <td align="right">{{order.title?order.title:order.cupType?order.cupType.beverage.name:'饮品'}}</td>
            </tr>
            <tr>
              <td>交易时间</td>
              <td align="right">{{order.createdOn}}</td>
            </tr>
            <tr>
              <td>交易单号</td>
              <td align="right">{{ order.orderNo }}</td>
            </tr>
          </table>

        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {getOrder} from '@/api/productApi.js'
import {getUrlParam} from "../utils/commonUtil";

export default {
  name: "Success",
  data(){
    return{
      order:{},//订单信息
      orderFrom:0//0接触1非接触
    }
  },
  methods:{
    /**
     * 跳转到首页
     */
    goToIndex(){
      let dtuNo = this.$route.query.dtuNo
      if(this.orderFrom == 0){
        this.$router.push({name:'ProductDetailTouch',params:{dtuNo:this.order.equipment.dtuNumber}})
      }else if(this.orderFrom == 1){
        this.$router.push({name:'Product',params:{dtuNo:dtuNo}})
      }else{
      }
    },
    /**
     * 根据订单号查询订单
     */
    getOrderByOrderNo(){
      getOrder({orderNo:this.order.orderNo}).then(res=>{
        if(res.code==200){
          this.order = {...res.data}
        }
      })
    }
  },
  created() {
    this.order.orderNo = this.$route.query.orderNo
    this.orderFrom = this.$route.query.orderFrom
  },
  mounted() {
    // 获取订单信息
    this.getOrderByOrderNo()
  }
}
</script>

<style lang="less">
#success{
  height: 100vh;
  a { text-decoration: none; color: #666666; }
  a, img { border: none; }
  img { vertical-align: middle; }
  ul, li { list-style: none; }
  em, i { font-style: normal; }
  .clear { clear: both }
  .clear_wl:after { content: "."; height: 0; visibility: hidden; display: block; clear: both; }
  .fl { float: left }
  .fr { float: right }
  .all_w { width: 91.3%; margin: 0 auto; }
  /********/
  .header { background: #393a3e; color: #f5f7f6; height: 46px; overflow: hidden; }
  .gofh { float: left; height: 45px; display: -webkit-box; -webkit-box-orient: horizontal; -webkit-box-pack: center; -webkit-box-align: center; }
  .gofh a { padding-right: 10px; border-right: 1px solid #2e2f33; }
  .gofh a img { width: 40%; }
  .ttwenz { float: left; height: 45px; }
  .ttwenz h4 { font-size: 16px; font-weight: 400; margin-top: 2px; }
  .ttwenz h5 { font-size: 12px; font-weight: 400; color: #6c7071; }
  .wenx_xx { text-align: center; font-size: 16px; padding: 18px 0; }
  .wenx_xx .wxzf_price { font-size: 45px;margin-top: 20px }
  .skf_xinf { height: 43px; border-top: 1px solid #ddd; border-bottom: 1px solid #ddd; line-height: 43px; background: #FFF; font-size: 12px; overflow: hidden; }
  .skf_xinf .bt { color: #767676; float: left; }
  .ljzf_but { border-radius: 3px; height: 45px; line-height: 45px; background: #44bf16; display: block; text-align: center; font-size: 16px; margin-top: 14px; color: #fff; }
  /**/
  .ftc_wzsf { display:none; width: 100%; height: 100%; position: fixed; z-index: 999; top: 0; left: 0; }
  .ftc_wzsf .hbbj { width: 100%; height: 100%; position: absolute; z-index: 8; background: #000; opacity: 0.4; top: 0; left: 0; }
  .ftc_wzsf .srzfmm_box { position: absolute; z-index: 10; background: #f8f8f8; width: 88%; left: 50%; margin-left: -44%; top: 25px; }
  .qsrzfmm_bt { font-size: 16px; border-bottom: 1px solid #c9daca; overflow: hidden; }
  .qsrzfmm_bt a { display: block; width: 10%; padding: 10px 0; text-align: center; }
  .qsrzfmm_bt img.tx { width: 10%; padding: 10px 0; }
  .qsrzfmm_bt span { padding: 15px 5px; }
  .zfmmxx_shop { text-align: center; font-size: 12px; padding: 10px 0; overflow: hidden; }
  .zfmmxx_shop .mz { font-size: 14px; float: left; width: 100%; }
  .zfmmxx_shop .wxzf_price { font-size: 24px; float: left; width: 100%; }
  .blank_yh { width: 89%; margin: 0 auto; line-height: 40px; display: block; color: #636363; font-size: 16px; padding: 5px 0; overflow: hidden; border-bottom: 1px solid #e6e6e6; border-top: 1px solid #e6e6e6; }
  .blank_yh img { height: 40px; }
  .ml5 { margin-left: 5px; }
  .mm_box { width: 89%; margin: 10px auto; height: 40px; overflow: hidden; border: 1px solid #bebebe; }
  .mm_box li { border-right: 1px solid #efefef; height: 40px; float: left; width: 16.3%; background: #FFF; }
  .mm_box li:last-child { border-right: none; }
  .xiaq_tb { padding: 5px 0; text-align: center; border-top: 1px solid #dadada; }
  .numb_box { position: absolute; z-index: 10; background: #f5f5f5; width: 100%; bottom: 0px; }
  .nub_ggg { border: 1px solid #dadada; overflow: hidden; border-bottom: none; }
  .nub_ggg li { width: 33.3333%; border-bottom: 1px solid #dadada; float: left; text-align: center; font-size: 22px; }
  .nub_ggg li a { display: block; color: #000; height: 50px; line-height: 50px; overflow: hidden; }
  .nub_ggg li a:active  { background: #e0e0e0;}
  .nub_ggg li a.zj_x { border-left: 1px solid #dadada; border-right: 1px solid #dadada; }
  .nub_ggg li span { display: block; color: #e0e0e0; background: #e0e0e0; height: 50px; line-height: 50px; overflow: hidden; }
  .nub_ggg li span.del img { width: 30%; }
  .fh_but{ position:absolute; right:0px; top:12px; font-size:14px; color:#20d81f;}
  .zfcg_box{ background:#f2f2f2;  height: 56px; line-height:56px;   font-size:20px; color:#1ea300; }
  .zfcg_box img{ width:10%;}

  .cgzf_info{
    background:#FFF;
    border-top:1px solid #dfdfdd;
    height: calc(100% - 110px);
  }

  .spxx_shop{ background:#FFF; margin-left:4.35%; border-top:1px solid #dfdfdd; padding:10px 0; }
  .spxx_shop td{ color:#7b7b7b; font-size:14px; padding:10px 0;}

  .wzxfcgde_tb{ position:fixed; width:100%; z-index:999; bottom:20px; text-align:center;}
  .wzxfcgde_tb img{ width:20.6%;}
  .mlr_pm{margin-right:4.35%;}
}


</style>



// WEBPACK FOOTER //
// src/components/AliSuccess.vue